import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import AnalyticsLogger from '../../../helpers/analytics/analyticsLogger';
import dataModel from '../../../models/DataModel';
import Animate from '../../../components/Animate';
import closeoutsService from '../../../services/closeoutsService';
import BaseComponent from '../../../baseClasses/BaseComponent';
import CompanyMembers from './CompanyMembers';

import './EmailUserSelectionPopup.scss';

export class EmailUserSelectionPopup extends BaseComponent {
  constructor(props) {
    super(props);
    
    this.state = {
      editing: false,
      projectMembers: [],
    };
    this.current = [];
    this.toBeAdded = [];
    this.toBeRemoved = [];
    this.doClose = this.doClose.bind(this);
  }

  componentDidMount() {
    const { currentUser } = this.props;
    const currentRole = currentUser ? currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });
  }

  handleKeyDown(e) {
    if (e.keyCode == 13 || e.keyCode == 40) {
      e.preventDefault();
      this.handleAddRemoveMembers();
    }
    else if (e.keyCode == 27) {
      e.preventDefault();
      this.handleClose();
    }
  }

  isUser(member) {
    return member.first_name || member.last_name;
  }

  isMemberOf(list, member) {
    const indexOf = list.findIndex((listMember) => {
      return (((this.isUser(member) && this.isUser(listMember)) || (!this.isUser(member) && !this.isUser(listMember))) && member.id == listMember.id);
    }, this);
    return indexOf;
  }

  setProjectMembers() {
    let projectMembers = [...this.toBeAdded];
    projectMembers = projectMembers.concat(this.current);
    this.setState({ projectMembers, editing: this.toBeAdded.length || this.toBeRemoved.length });
  }

  handleAddMember(member) {
    const element = document.getElementById('select-member-popup');
    if (element) {
      element.focus();
    }
    const toBeRemovedIndexOf = this.isMemberOf(this.toBeRemoved, member);
    if (toBeRemovedIndexOf >= 0) {
      // if in toBeRemoved then it must have been in current so put it back...
      this.toBeRemoved.splice(toBeRemovedIndexOf, 1);
      this.current.push(member);
    }
    else {
      // a "new" member
      this.toBeAdded.push(member);
    }
    this.setProjectMembers();
  }

  handleRemoveMember(member) {
    if (this.isUser(member)) {
      this.handleFinishRemoveMember(member);
    }
  }

  handleFinishRemoveMember(member) {
    const element = document.getElementById('select-member-popup');
    if (element) {
      element.focus();
    }
    const toBeAddedIndexOf = this.isMemberOf(this.toBeAdded, member);
    if (toBeAddedIndexOf >= 0) {
      // not a current member so just remove...
      this.toBeAdded.splice(toBeAddedIndexOf, 1);
    } 
    else {
      const currentIndexOf = this.isMemberOf(this.current, member);
      if (currentIndexOf >= 0) {
        this.current.splice(currentIndexOf, 1);
        this.toBeRemoved.push(member);
      }
    }
    this.setProjectMembers();
  }

  handleSendEmail(){
    const { attachmentIds } = this.props;
    const { projectMembers } = this.state;
    if(attachmentIds.length > 0 && projectMembers.length > 0){
      let userIds = [];
      projectMembers.forEach(member=>{
        userIds.push(member.id);
      });
      closeoutsService.emailCloseouts(attachmentIds, userIds);

      projectMembers.forEach(member=>{
        this.handleRemoveMember(member);
      });

      this.doClose();
    }
  }

  handleClose() {
    if (this.state.editing) {
      this.queryClose();
    }
    else {
      this.doClose();
    }
  }

  queryClose() {
    const message = 'No email has been sent. Are you sure you want to cancel?';

    dataModel.showGlobalModal('SYSTEM_POPUP', {
      message: message,
      cancelButtonText: this.textMap.no.toUpperCase(), 
      okButtonText: this.textMap.yes.toUpperCase(),
      width: 300, 
      height: 175, 
      handleOwnerOk: this.doClose, 
    });
  }

  doClose() {
    this.setState({ animateClose: true });
  }

  handleAnimateOut() {
    if (this.props.handleClosePopup) {
      this.props.handleClosePopup();
    }
  }

  handleBackgroundClicked(e) {
    if (e.target.className == 'select-member-background') {
      this.handleClose();
    }
  }

  render() {
    let { left, right, top, type } = this.props;

    let tabContent = null;
    tabContent = <CompanyMembers 
                      multiSelect={true} 
                      type={type}
                      companyId={this.props.companyId}
                      marketId={this.props.marketId}
                      handleAddMember={this.handleAddMember}
                      handleRemoveMember={this.handleRemoveMember}
                      projectMembers={this.state.projectMembers}
                    />;
    
    let style = {};
    if (left) {
      style = { top: top, left: left };
    }
    else {
      style = { top: top, right: right };
    }

    let buttonPanel = null;
    buttonPanel = <div className={'send-email-button' + (!this.state.editing ? ' disabled': '')} onClick={this.handleSendEmail}>Send Mail</div>;

    return (
      <div className="select-member-background" onClick={this.handleBackgroundClicked}>
        <div id={'select-member-popup'} className="select-member-popup"
          style={style}>
          <Animate key="animate_popup-in" component_id={'select-member-popup'} duration={500}
            property={{ height: { startVal: 0, endVal: 432 } }} />
          {this.state.animateClose && (
            <Animate key="animate_popup-out" component_id={'select-member-popup'} duration={500}
              property={{ height: { startVal: 432, endVal: 0 } }} completionCallback={this.handleAnimateOut} />
          )}
          <div className="close-button" onClick={this.handleClose}></div>
          <div className="caption">Select Member To Send Email</div>
          <div className="main-body">
            {tabContent}
          </div>  
          {buttonPanel}
        </div>
      </div>
   );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    permissions: state.new_users.permissions,
    currentCompany: state.new_companies.currentCompany,
    currentUser: state.new_users.currentUser,
  };
};

export default withRouter(connect(mapStateToProps)(EmailUserSelectionPopup));



// WEBPACK FOOTER //
// ./src/containers/PORContainer/EmailUserSelectionPopup/index.js